import Vue from 'vue'
import App from './views/App.vue'
import i18n from './lang/lang'
import router from './router'
import store from './store/store'
import vuetify from './plugins/vuetify'
import VueApexCharts from 'vue-apexcharts'

window.plotty = require('plotty')
window.Vue = require('vue')

const moment = require('moment')
require('moment/locale/de')
Vue.use(require('vue-moment'), {
  moment
})

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

const apexLocaleDe = require('apexcharts/dist/locales/de.json')
const apexLocaleIt = require('apexcharts/dist/locales/it.json')
const apexLocaleEn = require('apexcharts/dist/locales/en.json')
window.Apex.chart = {
  locales: [apexLocaleDe, apexLocaleEn, apexLocaleIt],
  defaultLocale: 'de'
}

Vue.config.productionTip = false

new Vue({
  vuetify,
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
